import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import styles from './Gallery.css'
import GalleryItem from "../../components/GalleryItem/GalleryItem"
import GalleryViewer from "../GalleryViewer/GalleryViewer"
import Modal from "../Modal/Modal"
import {isDesktop} from "../../services/service-utils"
import {TypeComponentGallery} from "../../constants/consts-prop-types"

class Gallery extends Component {
  static propTypes = {
    data: TypeComponentGallery
  }

  constructor(props) {
    super(props)

    this.state = {
      itemHeights: [],
      isDesktop: isDesktop(),
      modalOpen: false,
      currentGalleryIndex: 0,
      iiiFOpen: false,
      iiif_url: null
    }

    this.onImageLoaded = this.onImageLoaded.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.resetImageHeights = this.resetImageHeights.bind(this)
    this.renderGalleryItem = this.renderGalleryItem.bind(this)
    this.onImageClick = this.onImageClick.bind(this)
    this.onCloseClick = this.onCloseClick.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.resetImageHeights)

    this.unlisten = this.props.history.listen((location, action) => {
      // on browser-button BACK:
      if(action === 'POP') {
        this.closeModal()
      }
      // on browser-button FORWARD:
      if(action === 'POP' && location.search.includes(`modal=${this.props.componentIndex}`)) {
        console.log('openModal', this.props.componentIndex)
        this.openModal()
      }
    })

    if(this.props.location.search.includes(`modal=${this.props.componentIndex}`)) {
      console.log('openModal', this.props.componentIndex)
      this.openModal()
    }
  }

  componentWillUnmount() {
    this.unlisten()
    window.removeEventListener('resize', this.resetImageHeights)
  }

  resetImageHeights() {
    this.setState({
      itemHeights: [],
      isDesktop: isDesktop(),
    })
  }

  onImageLoaded(index, height) {
    const firstInRow = index % 2 === 0

    this.setState(prevState => {
      const newState = prevState.itemHeights

      if(firstInRow) {
        const secondInRowHeight = newState[index + 1]
        if(secondInRowHeight) {
          const maxHeight = Number(Math.max(height, secondInRowHeight).toFixed(2))
          newState[index] = maxHeight
          newState[index + 1] = maxHeight
        } else {
          newState[index] = Number(height.toFixed(2))
        }
      } else {
        const firstInRowHeight = newState[index - 1]
        if(firstInRowHeight) {
          const maxHeight = Number(Math.max(height, firstInRowHeight).toFixed(2))
          newState[index] = maxHeight
          newState[index - 1] = maxHeight
        } else {
          newState[index] = Number(height.toFixed(2))
        }
      }

      return {
        itemHeights: [...newState]
      }
    })
  }

  onImageClick(index) {
    this.setState({
      currentGalleryIndex: index
    }, () => {
      const hasSearchProps = this.props.location.search.includes('?')
      this.props.history.push(hasSearchProps ? `${this.props.location.search}&modal=${this.props.componentIndex}` : `?modal=${this.props.componentIndex}`)
      this.openModal()
    })
  }

  onCloseClick() {
    this.props.history.goBack()
    this.closeModal()
  }

  openModal() {
    this.setState({
      modalOpen: true
    })
  }

  closeModal() {
    this.setState({
      modalOpen: false,
      iiiFOpen: false
    })
  }

  isLastRow(idx, columnIndex, numItems) {
    if(!this.state.isDesktop) {
      return Boolean(idx === numItems - 1)
    }

    const threshold = numItems - 2 + columnIndex
    return idx >= threshold
  }

  renderGalleryItem(data, idx, array) {
    const numItems = array.length

    const itemData = {...data}
    itemData.imageContainerHeightEqualized = this.state.itemHeights[idx]

    // For single image:
    if(numItems === 1) {
      return (
        <div key={idx} className="col-xs-12">
          <GalleryItem
            index={idx}
            data={data}
            inLastRow={true}
            isDesktop={this.state.isDesktop}
            onImageClick={this.onImageClick}
          />
        </div>
      )
    }

    // For multiple images:
    const columnIndex = idx % 2

    const colClass = (function(columnIndex) {
      switch(columnIndex) {
        case 1:
          return 'col-xs-12 col-md-6 col-md-offset-1';
        default:
          return 'col-xs-12 col-md-5';
      }
    })(columnIndex)

    const isLastRow = this.isLastRow(idx, columnIndex, numItems)

    return (
        <div key={idx} className={colClass}>
          <GalleryItem
            index={idx}
            columnIndex={columnIndex}
            data={itemData}
            currentRoute={this.props.currentRoute}
            inLastRow={isLastRow}
            isDesktop={this.state.isDesktop}
            onImageLoaded={this.onImageLoaded}
            onImageClick={this.onImageClick}
          />
        </div>
    )
  }

  render() {
    const {currentRoute} = this.props
    const {title, items} = this.props.data
    const hasItems = Boolean(items && items.length > 0)
    if(!hasItems) return null

    const {
      modalOpen,
      currentGalleryIndex
    } = this.state

    return (
      <section className={styles.Gallery}>
        {title &&
          <div className="container-fluid">
            <div className="row">
              <h2 dangerouslySetInnerHTML={{__html: title}}/>
            </div>
          </div>
        }

        {hasItems &&
          <div className="container-fluid">
            <div className="row">
              {items.map((item, idx, array) => this.renderGalleryItem(item, idx, array))}
            </div>
          </div>
        }

        {modalOpen &&
          <Modal>
            <GalleryViewer
              currentRoute={currentRoute}
              items={items}
              numInview={1}
              currentIndex={currentGalleryIndex}
              onCloseClick={this.onCloseClick}
            />
          </Modal>
        }

      </section>
    )
  }
}

export default withRouter(Gallery)



// WEBPACK FOOTER //
// ./src/components/Gallery/Gallery.js